import BaseNodeModel from "../BaseNodeModel";

export default class BeginNodeModel extends BaseNodeModel {
    /**
     * Begin node model
     * @module BeginNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Module Begin";
        this.props.colorClass = "purple";
        this.props.iconClass = "log-in";
        this.DEFAULT_COLOR_CLASS = "purple";
        this.applyProps(props);
    }

    getConfigViews(){
        return [
            ...this.getConfigViewNameField(),
            ...[
                {type: "Textarea", label: this.getPropLabel("description"), key: "description"},
                {type: "ItemList", label: this.getPropLabel("outputs"), key: "outputs", view: "return"}
            ],
            ...this.props.configView,
            ...[
                {type: "hr"},
                {type: "Textarea", label: this.getPropLabel("note"), key: "note"}
            ]
        ];
    }
}